import { DeploymentCard, DeploymentCardSkeleton } from './DeploymentCard';
import { useDeploymentsContext } from '../context/DeploymentsContext';

import InfiniteScroll from '~/components/InfiniteScroll';

function GridContainer({ children }: { children: React.ReactNode }) {
  return (
    <div className='mb-10 grid grid-cols-[repeat(auto-fill,minmax(322px,1fr))] gap-6 [&>*]:max-w-[500px]'>
      {children}
    </div>
  );
}

export function DeploymentsGridView() {
  const {
    loading,
    onInfinityScroll,
    deploymentsList,
    deploymentsData,
    menuActionHandlers
  } = useDeploymentsContext();
  const size = deploymentsList?.size || 0;
  const hasMore = !deploymentsList?.last;
  const isInitialLoading = loading && deploymentsData.length === 0;

  if (isInitialLoading) {
    return (
      <GridContainer>
        {Array.from({ length: 10 }).map((_, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <DeploymentCardSkeleton key={index} />
        ))}
      </GridContainer>
    );
  }

  return (
    <InfiniteScroll
      scrollableTarget='scrollable-content'
      dataLength={size || 0}
      pageStart={0}
      style={{ overflow: 'hidden' }}
      hasMore={hasMore}
      next={onInfinityScroll}
      data-testid='run-deployments-list'
      innerRef={() => {}}
      showLoader={false}
    >
      <GridContainer>
        {deploymentsData.map(({ deployment }) => (
          <DeploymentCard
            key={deployment.id}
            deployment={deployment}
            menuActionHandlers={menuActionHandlers}
          />
        ))}
        {loading &&
          hasMore &&
          deploymentsData.length > 0 &&
          Array.from({ length: 6 }).map((_, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <DeploymentCardSkeleton key={index} />
          ))}
      </GridContainer>
    </InfiniteScroll>
  );
}
